import { Link } from 'react-router-dom';

const HowItWorksPreview = () => {
  const steps = [
    { number: '1', title: 'Apply to Join', description: 'Submit your application to join our exclusive broker network' },
    { number: '2', title: 'Access Wholesale', description: 'Get immediate access to wholesale trade lines and services' },
    { number: '3', title: 'Sell Packages', description: 'Offer business credit packages to your clients' },
    { number: '4', title: 'We Fulfill', description: 'Our team handles all the backend fulfillment work' },
    { number: '5', title: 'Earn Margins', description: 'You keep the profit margins on every sale' },
  ];

  return (
    <section className="bg-[#F2F4F7] py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="mb-16">
          <h2 className="text-5xl font-bold text-[#2F6FE4] mb-4">How It Works</h2>
          <div className="w-32 h-1 bg-[#3D8BFF]"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-8 mb-12">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-white rounded-2xl p-8 h-80 flex flex-col items-center text-center shadow-xl hover:shadow-2xl transition-all hover:-translate-y-2 border-t-4 border-[#3D8BFF]">
                <div className="w-16 h-16 flex items-center justify-center bg-[#2F6FE4] rounded-full mb-6 -mt-12 shadow-lg">
                  <span className="text-white text-3xl font-bold">{step.number}</span>
                </div>
                <h3 className="text-[#2F6FE4] text-xl font-bold mb-4">{step.title}</h3>
                <p className="text-[#555555] text-sm leading-relaxed">{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-8 -right-4 w-8 h-8 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-[#3D8BFF] text-2xl"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/how-it-works"
            className="inline-flex items-center space-x-2 text-[#2F6FE4] hover:text-[#3D8BFF] transition-colors font-semibold text-lg cursor-pointer"
          >
            <span>Learn More About Our Process</span>
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksPreview;